import { getRouteApi } from '@tanstack/react-router';

import { useProject } from '@/features/projects/api/projects';

const projectRoute = getRouteApi(
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout'
);

export const ProjectBreadcrumb = () => {
  const { projectId } = projectRoute.useParams();
  const { data: project } = useProject({ id: projectId });

  return <span className="flex items-center gap-2">{project?.name ?? 'Unnamed Project'}</span>;
};
